import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Entry from '../components/Entry'
import React from 'react'

const Delivery = props => {
  return (
    <div className={props.classes.delivery}>
      <Typography className={props.classes.deliveryLabel}>
        <b className={props.classes.deliveryCode}>Albarán {props.delivery.deliveryCode}</b>
        <div className={props.classes.entries}>
          {props.delivery.entries &&
            props.delivery.entries.length &&
            props.delivery.entries.map(entry => (
              <Entry key={entry.code} entry={entry} loadSampledEntryDirectAccess={props.loadSampledEntryDirectAccess} />
            ))}
        </div>
      </Typography>
    </div>
  )
}

const styles = {
  delivery: {
    backgroundImage: 'linear-gradient(-180deg, #A9A9A9 0%, #EBEBEB 100%)',
  },
  deliveryLabel: {
    padding: 10,
    color: 'white',
    fontSize: 13,
    fontWeight: 300,
  },
  deliveryCode: {
    fontWeight: 400,
  },
  goToDeliveryButton: {
    marginLeft: 10,
    padding: '3px 0 3px 6px',
    background: 'white',
    color: '#000',
    borderRadius: 4,
    fontWeight: 400,
  },
  entries: {
    color: 'rgb(50,50,50)',
  },
}

export default withStyles(styles)(Delivery)



// WEBPACK FOOTER //
// ./src/components/Delivery.js